import { Box, Typography } from '@mui/material';

const PQR_DETAIL_HINTS = [
    {
        label: 'Póliza',
        text: 'Digite el número de póliza de la cual requiere información',
    },
    {
        label: 'Ramo',
        text: 'Indicar el ramo del producto del cual requiere información',
    },
    {
        label: 'Tomador',
        text: 'Indicar el nombre del tomador de la póliza',
    },
    {
        label: 'Nit y/o CC',
        text: 'Indicar el Nit o Cédula del tomador de la póliza',
    },
    {
        label: 'Placa',
        text: 'Relacionar la placa del automotor, si su petición corresponde al ramo de Automóviles o SOAT',
    },
    {
        label: 'Nro. Siniestro',
        text: 'Relacionar el número de siniestro si su petición corresponde a un proceso de indemnización',
    },
    {
        label: 'Caso On base',
        text: 'Indicar el número de caso, si su petición corresponde a un proceso de indemnización',
    },
    {
        label: 'Nro. Expediente o Servicio',
        text: 'Relacionar el número de servicio, si su petición corresponde a un tema de asistencia',
    },
    {
        label: 'Radicado de Correspondencia',
        text: 'En este campo relacionar el número de radicado asignado por la Compañía. Ej.: 2019-CR-0131152-0000-01',
    },
    {
        label: 'Detalle PQR',
        text: 'Describa la petición, inconformidad, felicitación o sugerencia, en la cual se relacionen datos como: hora, fechas, sitio dónde presentó el evento, etc. La información suministrada será utilizada para el trámite.',
    },
];

const NUMERALS = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

export const PqrDetailTooltipContent = () => (
    <Box component="div" sx={{ p: 0.5, color: 'inherit' }}>
        <Typography
            variant="body2"
            sx={{ mb: 1, fontWeight: 600, color: 'inherit' }}
        >
            Con el fin de facilitar el proceso de PQR agradecemos relacionar
            algunos de los siguientes datos:
        </Typography>
        {PQR_DETAIL_HINTS.map(({ label, text }, index) => (
            <Typography
                key={label}
                variant="body2"
                component="p"
                sx={{ mb: 0.5, lineHeight: 1.45, color: 'inherit' }}
            >
                {NUMERALS[index]}. <strong>{label}:</strong> {text}
            </Typography>
        ))}
    </Box>
);
